import React, { useEffect } from "react";
import cardImage1 from "../../assets/images/webp/about-card-1.webp";
import cardImage2 from "../../assets/images/webp/about-card-2.webp";
import ChooseUs from "./choose-us/ChooseUs";
import Gallery from "./Gallery";
import Hero from "./hero/Hero";
import Innovate from "./Innovate";
import LatestNews from "./LatestNews";
import OurServices from "./OurServices";
import Testimonials from "./testimonials/Testimonials";
import HomeAbout from "./HomeAbout";
const Home = () => {
  const AboutList = {
    title: "A journey driven by passion and innovation",
    description: [
      "At Make Way India, we are dedicated to transforming visions into reality through innovation and strategic excellence. With a focus on sustainable growth, our expertise spans diverse industries, ensuring impactful solutions that resonate with our clients' needs.",
    ],
    listBadges: [
      "Deliver exceptional customer experiences through tailored solutions.",
      "Leverage cutting-edge technologies and marketing strategies.",
      "Expand your reach with innovative and AI-driven products.",
    ],
    infoHeading:
      "Our mission is to revolutionize industries through creativity, integrity, and collaboration.",
    cta: true,
    second: {
      title: "",
      description: [
        "We've proudly served over 12,000 clients, delivering innovative solutions and building lasting relationships.",
      ],
      img1: cardImage1,
      img2: cardImage2,
    },
  };
  useEffect(() => {
    document.getElementById("title-page").innerHTML = "Make My Way";
  }, []);

  return (
    <>
      <Hero />
      <HomeAbout AboutList={AboutList} />
      <ChooseUs />
      <OurServices />
      <Gallery />
      <LatestNews />
      <Testimonials isMax />
      <Innovate />
    </>
  );
};

export default Home;
